import React, { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebaseConfig";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import AccountingSidebar from "./AccountingSidebar";

export default function AccountingShell({ title, children }) {
  const auth = getAuth();
  const navigate = useNavigate();

  const [me, setMe] = useState(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      if (!u) {
        navigate("/accounting-login");
        return;
      }

      const snap = await getDoc(doc(db, "account_users", u.uid));

      if (!snap.exists()) {
        toast.error("Accounting access not found");
        navigate("/accounting-login");
        return;
      }

      const userData = { uid: u.uid, email: u.email, ...snap.data() };

      if (!userData.active || !["CEO", "ACCOUNTANT"].includes(userData.role)) {
        toast.error("Only CEO / Accountant allowed");
        navigate("/accounting-login");
        return;
      }

      setMe(userData);
    });

    return () => unsub();
  }, [auth, navigate]);

  const logout = async () => {
    await signOut(auth);
    navigate("/accounting-login");
  };

  if (!me) return null;

  return (
    <div className="min-h-screen bg-slate-100 flex">
      <Toaster position="top-center" />

      <AccountingSidebar role={me.role} />

      <main className="flex-1">
        <header className="bg-white border-b px-8 py-5 flex justify-between">
          <div>
            <h1 className="text-2xl font-black text-slate-900">
              {title || "Accounting Dashboard"}
            </h1>
            <p className="text-sm text-slate-500">
              Vendor Fee, Tender Fee, EMD, RA Bill, Ledger & CEO Approval
            </p>
          </div>

          <div className="text-right">
            <p className="font-bold">{me.name || me.email}</p>
            <p className="text-xs font-black text-emerald-600">{me.role}</p>
            <button onClick={logout} className="text-xs underline mt-1">
              Logout
            </button>
          </div>
        </header>

        <section className="p-8">
          {React.cloneElement(children, { me })}
        </section>
      </main>
    </div>
  );
}